import BossModel from "@/models/BossModel";

export default class BackofficeMessage extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'dossier/backoffice-message';

    /**
     *
     * @type {string}
     */
    static entity = 'backofficeMessages';

    static fields() {
		return {
			id: this.attr(null),
			message: this.attr(null),
			user_id: this.number(null).nullable(),
            dossier_id: this.number(null).nullable(),
            created_at: this.string(null).nullable(),
            updated_at: this.string(null).nullable(),
		}
	}

    static loadByDossier(dossierId){
        return this.api()
            .where('dossier_id', dossierId)
            .limit(0)
            .get(true);
    }
}
